"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowTextEditor_1 = require("../../../../shared/components/editors/CardRowTextEditor");
var DlgGenerateOnePromoCodeOperation = /** @class */ (function (_super) {
    __extends(DlgGenerateOnePromoCodeOperation, _super);
    function DlgGenerateOnePromoCodeOperation(props) {
        return _super.call(this, props) || this;
    }
    DlgGenerateOnePromoCodeOperation.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.title,
                promoTypeTitle: data.promo_type_title
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            dialogTitle: this.props.controller.DATA.title,
            promoTypeTitle: this.props.controller.DATA.promo_type_title,
            code: "",
            description: ""
        });
        this.doReSetRules();
    };
    DlgGenerateOnePromoCodeOperation.prototype.doReSetRules = function () {
        this.setState({
            code_rules: { isError: false },
        });
    };
    DlgGenerateOnePromoCodeOperation.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgGenerateOnePromoCodeOperation.prototype.isDataValid = function () {
        this.doReSetRules();
        if (!this.state.code) {
            this.setState({ code_rules: { isError: true, errorMessage: "Поле [код] заполнено некорректно!" } });
            return false;
        }
        if (this.state.code.length < 3) {
            this.setState({ code_rules: { isError: true, errorMessage: "Поле [код] слишком короткое!" } });
            return false;
        }
        return true;
    };
    DlgGenerateOnePromoCodeOperation.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.code, this.state.description);
            }
        }
    };
    DlgGenerateOnePromoCodeOperation.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgGenerateOnePromoCodeOperation.prototype.OnDescriptionChanged = function (newValue) {
        this.setState({ description: newValue });
    };
    DlgGenerateOnePromoCodeOperation.prototype.OnPromoCodehanged = function (newValue) {
        this.setState({ code: newValue, code_rules: { isError: false } });
    };
    DlgGenerateOnePromoCodeOperation.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "primary", style: { minWidth: 600 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowTextEditor_1.default, { disabled: true, texts: { caption: "Тип промокода", placeholder: "Тип промокода" }, value: this.state.promoTypeTitle, onValueChanged: null }),
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Значение промокода", placeholder: "Введите значение промокода" }, onValueChanged: this.OnPromoCodehanged.bind(this), value: this.state.code, required: true, rules: this.state.code_rules }),
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Комментарий операции", placeholder: "Введите комментарий" }, onValueChanged: this.OnDescriptionChanged.bind(this), value: this.state.description })));
    };
    return DlgGenerateOnePromoCodeOperation;
}(React.Component));
exports.default = DlgGenerateOnePromoCodeOperation;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgGenerateOnePromoCodeOperation.tsx
// module id = 2485
// module chunks = 0